export default function Terms() {
  const style = `
    @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,wght@0,900;1,900&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: 'Plus Jakarta Sans', sans-serif; background: #FAF7F2; color: #1E1040; }
    .legal-nav { background: #fff; border-bottom: 1px solid #EDE9E3; padding: 16px 48px; display: flex; align-items: center; justify-content: space-between; }
    .legal-logo { font-family: 'Fraunces', serif; font-weight: 900; font-size: 22px; color: #1E1040; text-decoration: none; }
    .legal-logo span { color: #8B5CF6; font-style: italic; }
    .legal-wrap { max-width: 760px; margin: 0 auto; padding: 60px 48px; }
    .legal-eyebrow { font-size: 11px; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; color: #8B5CF6; margin-bottom: 12px; }
    .legal-title { font-family: 'Fraunces', serif; font-weight: 900; font-size: 42px; color: #1E1040; margin-bottom: 8px; line-height: 1.1; }
    .legal-date { font-size: 13px; color: #9CA3AF; margin-bottom: 48px; }
    .legal-intro { font-size: 16px; color: #374151; line-height: 1.8; margin-bottom: 40px; padding: 24px; background: rgba(139,92,246,0.04); border: 1px solid rgba(139,92,246,0.1); border-radius: 14px; }
    .legal-section { margin-bottom: 36px; }
    .legal-section h2 { font-family: 'Fraunces', serif; font-weight: 900; font-size: 22px; color: #1E1040; margin-bottom: 14px; }
    .legal-section p { font-size: 15px; color: #374151; line-height: 1.8; margin-bottom: 12px; }
    .legal-section ul { list-style: none; margin: 0 0 12px 0; display: flex; flex-direction: column; gap: 8px; }
    .legal-section ul li { font-size: 15px; color: #374151; line-height: 1.6; padding-left: 20px; position: relative; }
    .legal-section ul li::before { content: '·'; position: absolute; left: 0; color: #8B5CF6; font-weight: 700; }
    .legal-section a { color: #8B5CF6; text-decoration: none; }
    .legal-section a:hover { text-decoration: underline; }
    .legal-footer { margin-top: 60px; padding-top: 32px; border-top: 1px solid #EDE9E3; display: flex; gap: 24px; flex-wrap: wrap; }
    .legal-footer a { font-size: 13px; color: #9CA3AF; text-decoration: none; transition: color 0.2s; }
    .legal-footer a:hover { color: #8B5CF6; }
    @media(max-width:640px){ .legal-wrap { padding: 40px 24px; } .legal-nav { padding: 16px 24px; } }
  `;

  return (
    <>
      <style>{style}</style>
      <nav className="legal-nav">
        <a href="/" className="legal-logo">Merq<span>Legacy</span></a>
        <a href="mailto:hello@getmerq.com" style={{fontSize:13,color:'#9CA3AF',textDecoration:'none'}}>hello@getmerq.com</a>
      </nav>
      <div className="legal-wrap">
        <div className="legal-eyebrow">Legal</div>
        <h1 className="legal-title">Terms of Service</h1>
        <div className="legal-date">Last updated: April 10, 2026</div>

        <div className="legal-intro">
          By using Merq Legacy, you agree to these terms. We've written them as clearly as possible. If something doesn't make sense, email us at <a href="mailto:hello@getmerq.com" style={{color:'#8B5CF6'}}>hello@getmerq.com</a>.
        </div>

        <div className="legal-section">
          <h2>Who We Are</h2>
          <p>Merq Legacy is operated by <strong>Merq Software</strong>, a sole proprietorship based in Texas, United States. References to "we," "us," or "our" refer to Merq Software. References to "you" refer to the person using the application.</p>
        </div>

        <div className="legal-section">
          <h2>What Merq Legacy Is</h2>
          <p>Merq Legacy is a family estate organizer — a secure digital place to store information your family will need when you're no longer able to provide it yourself.</p>
          <p><strong>Merq Legacy is not:</strong></p>
          <ul>
            <li>A law firm or legal service</li>
            <li>A financial advisor or investment service</li>
            <li>A will or trust generator</li>
            <li>A replacement for proper legal estate planning</li>
          </ul>
          <p>Nothing in Merq Legacy constitutes legal or financial advice. We strongly encourage you to work with qualified attorneys and financial advisors for your estate planning needs.</p>
        </div>

        <div className="legal-section">
          <h2>Your Account</h2>
          <p>To use Merq Legacy you must create an account with a valid email address. You are responsible for:</p>
          <ul>
            <li>Keeping your login credentials secure and confidential</li>
            <li>All activity that occurs under your account</li>
            <li>Notifying us immediately at <a href="mailto:hello@getmerq.com">hello@getmerq.com</a> if you suspect unauthorized access</li>
          </ul>
          <p>You must be at least 18 years old to create an account.</p>
        </div>

        <div className="legal-section">
          <h2>Subscription and Billing</h2>
          <p>Merq Legacy is a paid service at $69/year. Billing is handled securely by Paddle. By subscribing, you authorize Paddle to charge your payment method on an annual basis.</p>
          <ul>
            <li>Your subscription renews automatically each year unless cancelled</li>
            <li>You may cancel at any time from your account settings</li>
            <li>Cancellation takes effect at the end of your current billing period</li>
            <li>We offer a 30-day money-back guarantee — see our <a href="/refund">Refund Policy</a></li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>Your Data</h2>
          <p>You own your data. The information you store in Merq Legacy belongs to you. We store it securely to provide the service and will never sell it, share it with advertisers, or use it for any purpose other than operating the service.</p>
          <p>See our <a href="/privacy">Privacy Policy</a> for full details on how we handle your data.</p>
        </div>

        <div className="legal-section">
          <h2>Vault Guardian System</h2>
          <p>The Vault Guardian system allows designated trusted people to collectively approve access to your vault. By designating Vault Guardians:</p>
          <ul>
            <li>You authorize us to send invitation emails to the people you designate</li>
            <li>You acknowledge that vault access requires the minimum number of Guardian approvals you set</li>
            <li>You understand that Merq Software cannot override the Guardian approval system under any circumstances</li>
            <li>You are responsible for keeping your Guardian designations current</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use Merq Legacy for any unlawful purpose</li>
            <li>Attempt to gain unauthorized access to another person's vault</li>
            <li>Upload content that violates any law or third-party rights</li>
            <li>Interfere with or disrupt the service or its infrastructure</li>
            <li>Misrepresent yourself when acting as a Vault Guardian</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>Service Availability</h2>
          <p>We work hard to keep Merq Legacy available and reliable. However, we cannot guarantee uninterrupted access. We are not liable for any loss or damage caused by service interruptions, data loss, or technical failures, though we will do everything we can to prevent and address them promptly.</p>
        </div>

        <div className="legal-section">
          <h2>Termination</h2>
          <p>We reserve the right to suspend or terminate accounts that violate these terms. You may delete your account at any time by contacting us at <a href="mailto:hello@getmerq.com">hello@getmerq.com</a>. Upon account deletion, your data will be removed within 30 days.</p>
        </div>

        <div className="legal-section">
          <h2>Limitation of Liability</h2>
          <p>To the maximum extent permitted by law, Merq Software shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of Merq Legacy. Our total liability shall not exceed the amount you paid us in the 12 months prior to the claim.</p>
        </div>

        <div className="legal-section">
          <h2>Governing Law</h2>
          <p>These Terms are governed by the laws of the State of Texas, United States, without regard to its conflict of law provisions.</p>
        </div>

        <div className="legal-section">
          <h2>Changes to These Terms</h2>
          <p>We may update these Terms from time to time. We will notify you of significant changes by email. Continued use of the service after changes constitutes acceptance of the updated terms.</p>
        </div>

        <div className="legal-section">
          <h2>Contact Us</h2>
          <p><a href="mailto:hello@getmerq.com">hello@getmerq.com</a><br />Merq Software · Texas, United States</p>
        </div>

        <div className="legal-footer">
          <a href="/">Home</a>
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
          <a href="/refund">Refund Policy</a>
          <a href="mailto:hello@getmerq.com">Contact</a>
        </div>
      </div>
    </>
  );
}
